module.exports = __webpack_public_path__ + "static/media/DAZN_old.fa3900f2.png";